import { VisualizationDtoTypeEnum } from '../../../../../../typescript-axios';
import { ParameterSchema } from './visualization_parameters_handler';


export interface VisualizationConstraints<TParams = Record<string, any>> {
    minW: number;
    maxW: number;
    minH: number;
    maxH: number;
    defaultW: number;
    defaultH: number;
    data_type: 'datasource' | 'metric';
    show_top_bar: boolean;
    parameterSchema: ParameterSchema<TParams>;
}


export interface TableParameters {
    num_rows?: number;

    // enumerate rows!
    // TODO: Future functionality
    // page_size;
    // sortable;
    // columns;
}

export interface LineChartParameters {
    x_axis;
    y_axes;
    show_legend?;
    group_series_by?;
    // TODO: Future functionality
    // color
}

export interface AreaChartParameters {
    x_axis;
    y_axes;
    show_legend?;
    group_series_by?;
}

export interface BarChartParameters {
    x_axis;
    y_axes;
    show_legend?;
    group_series_by?;
    layout?;
    stacked?;
}

export interface CardParameters {
    title;
    icon;
    color;
}

export const VISUALIZATION_CONSTRAINTS: {
    [VisualizationDtoTypeEnum.Table]: VisualizationConstraints<TableParameters>;
    [VisualizationDtoTypeEnum.LineChart]: VisualizationConstraints<LineChartParameters>;
    [VisualizationDtoTypeEnum.AreaChart]: VisualizationConstraints<AreaChartParameters>;
    [VisualizationDtoTypeEnum.BarChart]: VisualizationConstraints<BarChartParameters>;
    [VisualizationDtoTypeEnum.Card]: VisualizationConstraints<CardParameters>;
} = {
    [VisualizationDtoTypeEnum.Table]: {
        minW: 2,
        maxW: 20,
        minH: 5,
        maxH: 20,
        defaultW: 4,
        defaultH: 10,
        data_type: 'datasource',
        show_top_bar: true,
        parameterSchema: {
            num_rows: { type: 'number', required: false },
        },
    },
    [VisualizationDtoTypeEnum.LineChart]: {
        minW: 5,
        maxW: 20,
        minH: 5,
        maxH: 20,
        defaultW: 6,
        defaultH: 10,
        data_type: 'datasource',
        show_top_bar: true,
        parameterSchema: {
            x_axis: { type: 'column', required: true },
            y_axes: { type: 'column[]', required: true },
            show_legend: { type: 'boolean', required: false, default: true },
            group_series_by: { type: 'column', required: false }
        },
    },
    [VisualizationDtoTypeEnum.AreaChart]: {
        minW: 5,
        maxW: 20,
        minH: 5,
        maxH: 20,
        defaultW: 6,
        defaultH: 10,
        data_type: 'datasource',
        show_top_bar: true,
        parameterSchema: {
            x_axis: { type: 'column', required: true },
            y_axes: { type: 'column[]', required: true },
            group_series_by: { type: 'column', required: false },
            show_legend: { type: 'boolean', required: false, default: true },
        },
    },
    [VisualizationDtoTypeEnum.BarChart]: {
        minW: 5,
        maxW: 20,
        minH: 5,
        maxH: 20,
        defaultW: 6,
        defaultH: 10,
        data_type: 'datasource',
        show_top_bar: true,
        parameterSchema: {
            x_axis: { type: 'column', required: true },
            y_axes: { type: 'column[]', required: true },
            group_series_by: { type: 'column', required: false },
            show_legend: { type: 'boolean', required: false, default: true },
            layout: { type: 'string', required: false, default: 'horizontal', allowedValues: ['horizontal', 'vertical'] },
            stacked: { type: 'boolean', required: false, default: false }
        },
    },
    [VisualizationDtoTypeEnum.Card]: {
        minW: 2,
        maxW: 5,
        minH: 2,
        maxH: 5,
        defaultW: 2,
        defaultH: 2,
        data_type: 'metric',
        show_top_bar: false,
        parameterSchema: {
            title: { type: 'string', required: true },
            icon: { type: 'string', required: true, allowedValues: ['users', 'sync', 'clock', 'directions'] },
            color: { type: 'string', required: true, allowedValues: ['blue', 'purple', 'green', 'orange'] },
        },
    },
};